import { render } from "./DropdownAddressBorder.vue?vue&type=template&id=d59ea2bc&scoped=true"
import script from "./DropdownAddressBorder.vue?vue&type=script&lang=js"
export * from "./DropdownAddressBorder.vue?vue&type=script&lang=js"

import "./DropdownAddressBorder.vue?vue&type=style&index=0&id=d59ea2bc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59ea2bc"]])

export default __exports__